import {createDialog} from './dialog';
import {addBatchItem} from './batch-menu';
// @ts-ignore
let $ = window.jQuery;

export function displayActions(entryIDs: number[]): void {
    let actionCards = '';
    for (const i in PDFGeneratorFormSettings.actions) {
        const action = PDFGeneratorFormSettings.actions[i];
        if (!action.enabled) {
            continue;
        }
        actionCards += `<div class="gf-pdf-action-card" data-action-key="${action.key}">
            <h5>${action.title}</h5>
            <p>${action.description}</p>
        </div>`;
    }

    const dialog = createDialog(`<div class="gf-pdf-modal-close gf-pdf-button -small -cancel">${PDFGenerator.text_cancel}</div>`, actionCards);
    dialog[0].showModal();

    dialog.on('click', '.gf-pdf-action-card', function (e) {
        const actionKey = $(this).data('action-key');
        triggerAction(PDFGeneratorFormSettings.actions[actionKey], entryIDs);
        dialog.remove();
    });
}

export function triggerAction(action: PDFAction, entryIDs: number[], layoutID?: string) {
    if (!layoutID) {
        layoutID = action.use_blank_template ? 'blank' : 'default';
    }
    $('body').trigger('pdfAction', [action, entryIDs, layoutID]);
}

export function addActionCardsButton() {
    addBatchItem($(`<button class="gf-pdf-button gf-pdf-batch-actions">${PDFGenerator.text_more_actions}&nbsp;<span class="gf-pdf-icon-more-horizontal"></span></button>`));
}

$('body').on('click', '.gf-pdf-actions', function (e) {
    e.preventDefault();

    const entryID = $(this).data('entry-id');
    displayActions([entryID]);
}).on('click', '.gf-pdf-batch-actions', function (e) {
    e.preventDefault();
    const entryIDs = $('input[name="entries[]"]:checked').map(function () {
        return $(this).val() as number;
    }).get();

    if (entryIDs.length === 0) {
        return;
    }

    displayActions(entryIDs);
});